import React from 'react';
import {
  Box, Chip, Container, Stack, Typography,
} from '@mui/material';
import {
  Link,
  ReviewCard,
  useReviews,
  decodeHTMLEntities,
  getFormattedDateShortMonthDDYYYY,
  replaceNewLine,
} from '@marageti/z4-lib';
import { useParams } from 'react-router-dom';
import { ReviewStatus } from '@marageti/z4-sdk/lib/travel';
import { getRatingNumber } from '../../../utils/helpers';

const View = () => {
  const { travelerId } = useParams<{ travelerId: string }>();
  const { reviews } = useReviews({
    searchItemId: travelerId,
    searchItemFieldName: 'travelerId',
  });

  return (
    <Container maxWidth="md" sx={{ boxSizing: { desktop: 'content-box' } }}>
      <Box
        sx={{
          py: 4,
        }}
      >
        <Typography variant="h2" sx={{ mb: 3 }}>
          Reviews
        </Typography>
        <Stack spacing={1.5}>
          {(reviews && reviews.length === 0) && (
            <Container maxWidth="md">
              <Box
                sx={{
                  py: { desktop: 6.5, mobile: 3.5 },
                }}
              >
                <Typography variant="body" textAlign="center">
                  There are no reviews to display
                </Typography>
              </Box>
            </Container>
          )}
          {reviews && reviews.map((review) => (
            <Link
              key={review.id}
              to={`/reviews/${review.id}`}
              state={{ review }}
            >
              <ReviewCard
                title={review.status === ReviewStatus.ReviewStatusPending ? 'Draft' : replaceNewLine(decodeHTMLEntities(review.title)) || '-'}
                titleTypographyProps={{
                  fontStyle: review.status === ReviewStatus.ReviewStatusPending ? 'italic' : undefined,
                }}
                subtitle={`${review.travelerName} • ${getFormattedDateShortMonthDDYYYY(review.createdAt)}`}
                avatar={{ src: review.travelerAvatar, name: review.travelerName }}
                rating={getRatingNumber(review.rating)}
                chips={review.published ? (
                  <Chip
                    label="Published"
                    variant="filled"
                    size="small"
                    sx={{
                      backgroundColor: (theme) => theme.palette.common.green25,
                    }}
                  />
                ) : (
                  <Chip
                    variant="outlined"
                    label="Unpublished"
                    size="small"
                  />
                )}
              />
            </Link>
          ))}
        </Stack>
      </Box>
    </Container>
  );
};

export default View;
